import { DossierId } from '../../../../../../../resources/dossier/types';
import { logInfo, logError, logWarn } from '../../../../../../../shared/datadog/logger';

export class LatencyLogger {
    globalContext: { [key: string]: unknown } = {};
    constructor(
        private readonly dossierId: DossierId,
        private readonly locale: string,
        private readonly sendingMessageId: string,
    ) {
        this.globalContext = {
            dossierId: this.dossierId,
            locale: this.locale,
            messageId: this.sendingMessageId,
        };
    }

    info(id: string, message: string, context: { [key: string]: unknown }) {
        this.log('info', id, message, context);
    }

    warning(id: string, message: string, context: { [key: string]: unknown }) {
        this.log('warning', id, message, context);
    }

    error(id: string, message: string, context: { [key: string]: unknown }, error?: unknown) {
        let formatedError;
        if (error instanceof Error) {
            formatedError = error.message;
        } else {
            formatedError = JSON.stringify(error);
        }
        this.log('error', id, message, { ...context, error: formatedError });
    }

    private log(
        type: 'info' | 'error' | 'warning',
        id: string,
        message: string,
        context: { [key: string]: unknown },
    ) {
        if (type === 'info') {
            logInfo(`[Latency] ${id} - ${message}`, { ...this.globalContext, ...context });
        } else if (type === 'error') {
            logError(`[Latency] ${id} - ${message}`, { ...this.globalContext, ...context });
        } else if (type === 'warning') {
            logWarn(`[Latency] ${id} - ${message}`, { ...this.globalContext, ...context });
        }
    }
}
